import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@mui/material";
import "./ApplicationDetailsDSA.css";

// SDD01MARKETPLACE488R120:
// CODE01MARKETPLACE488R120: Display DSA Details when European Countries are Targeted
// Related items (auto-generated):
// End related items

// SDD02MARKETPLACE496R120:
// CODE02MARKETPLACE496R120: DSA Compliance Checkbox Requirement for Approval
// Related items (auto-generated):
// End related items
function ApplicationDetailsDSA({ submissionData }) {
  const dsaData = {
    businessEntityName:
      submissionData?.dsaInfo.businessEntities[0].entityName || "",
    registrationNumber:
      submissionData?.dsaInfo.businessEntities[0].companyRegNumber || "",
    countryOfRegistration:
      submissionData?.dsaInfo.businessEntities[0].countryOfReg || "",
    email: submissionData?.dsaInfo.businessEntities[0].email || "",
    contactNumber:
      submissionData?.dsaInfo.businessEntities[0].phoneNumber || "",
  };

  const address = {
  city : submissionData?.dsaInfo.businessEntities[0].city,
  state : submissionData?.dsaInfo.businessEntities[0].state,
  country: submissionData?.dsaInfo.businessEntities[0].country,
  zip : submissionData?.dsaInfo.businessEntities[0].zip
  }
 
  const mappingAddress = Object.values(address).join(", ");
  const renderFieldValue = (value) => {
    if (!value || value.trim() === "") {
      return <span className="dsa-field-value-empty">Not provided</span>;
    }
    
    const needsTooltip = value.length > 30;
    const displayValue = needsTooltip ? value.substring(0, 30) + "..." : value;
    
    if (needsTooltip) {
      return (
        <Tooltip title={value} arrow>
          <span className="dsa-field-value">{displayValue}</span>
        </Tooltip>
      );
    }
    
    return <span className="dsa-field-value">{displayValue}</span>;
  };

  return (
    <div className="dsa-details-container">
      <h2 className="dsa-details-header">DSA Details</h2>
      <p className="dsa-details-description">Description goes here</p>

      <div className="dsa-details-grid">
        <div className="dsa-field">
          <span className="dsa-field-label">Business Entity Name</span>
          {renderFieldValue(dsaData.businessEntityName)}
        </div>

        <div className="dsa-field">
          <span className="dsa-field-label">Registration Number</span>
          {renderFieldValue(dsaData.registrationNumber)}
        </div>

        <div className="dsa-field">
          <span className="dsa-field-label">Country of Registration</span>
          {renderFieldValue(dsaData.countryOfRegistration)}
        </div>

        <div className="dsa-field">
          <span className="dsa-field-label">Email</span>
          {renderFieldValue(dsaData.email)}
        </div>

        <div className="dsa-field">
          <span className="dsa-field-label">Contact Number</span>
          {renderFieldValue(dsaData.contactNumber)}
        </div>

        <div className="dsa-field">
          <span className="dsa-field-label">Address</span>
           <span className="dsa-field-value"> {mappingAddress}</span> 
        </div>
      </div>
    </div>
  );
}

ApplicationDetailsDSA.propTypes = {
  submissionData: PropTypes.object,
};

export default ApplicationDetailsDSA;
